// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cN","text":"cO"};